// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".save_btn[data-v-778a2879]{display:flex;justify-content:center}", "",{"version":3,"sources":["webpack://./resources/js/components/gbp/listing/includes/EditListing.vue"],"names":[],"mappings":"AACA,2BACE,YAAA,CACA,sBAAA","sourcesContent":["\n.save_btn {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
